import React from 'react';

import { SVGComponentProps } from './svg.types';

const ReplyAllSVG = ({
  fill = 'none',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M4.66659 11.3333L1.33325 7.99996L4.66659 4.66663"
          stroke="#131720"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.00008 11.3333L4.66675 7.99996L8.00008 4.66663"
          stroke="#131720"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6667 12V10.6667C14.6667 9.95942 14.3858 9.28115 13.8857 8.78105C13.3856 8.28095 12.7073 8 12.0001 8H4.66675"
          stroke="#131720"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default ReplyAllSVG;
